<template>
  <div>
    <DxDataGrid
      :columns="itemHeaders"
      :summary="summary"
      :data-source="lineItems.data"
      :show-borders="true"
      :allow-column-resizing="true"
      :showRowLines="true"
      key-expr="id"
      format="dd/MM/yyyy"
      :toolbar="toolbar"
      @cell-prepared="onCellPrepared"
      :ref="itemDataGridRefKey"
      :onCellClick="handleCellClick"
      @focused-cell-changed="onFocusCellChanged"
    >
      <DxEditing
        :allow-updating="true"
        :allow-deleting="true"
        mode="batch"
        :select-text-on-edit-start="true"
        :new-row-position="newRowPosition"
        :use-icons="true"
        start-edit-action="click"
      />

      <template #cstm-field="{ data: cellData }">
        <div>
          <custom-field-types-list
            :item="cellData"
            :on-value-changed="cellData.setValue"
            :prefix="slug"
            :fieldDef="itemHeaders[cellData.columnIndex]"
          >
          </custom-field-types-list>
        </div>
      </template>
      <template #rlt-field-show="{ data: cellData }">
        <div>
          <relate-show
            :cellData="cellData"
            :prefix="slug"
            :currentRoute="cellData.columnIndex"
            :fieldDef="itemHeaders[cellData.columnIndex]"
          >
          </relate-show>
        </div>
      </template>
    </DxDataGrid>

    <div class="grid grid-cols-2 gap-4">
      <div class="line-add-button">
        <DxButton
          text="Add"
          type="normal"
          icon="plus"
          styling-mode="contained"
          @click="addNewRow()"
        />
      </div>
    </div>
  </div>
</template>
<script>
import { DxDataGrid, DxColumn, DxEditing } from "devextreme-vue/data-grid";
import CustomFieldTypesList from "./CustomFieldTypesforList.vue";
import RelateShow from "./line_item/ListRelateFieldShow.vue";
import DxButton from "devextreme-vue/button";
import DxDateBox from "devextreme-vue/date-box";
import CustomStore from "devextreme/data/custom_store";
import { isProxy, isArrayProxy, isProxy1 } from "./builder/base.js";

//const itemDataGridRefKey = "itemDataGrid";
const ledgerDataGridRefKey = "ledgerDataGrid";

let sTotal = 0;

export default {
  props: {
    modelValue: {
      type: Object,
      default: () => ({}),
      required: true,
    },
    def: {
      type: Object,
      default: () => ({}),
      required: true,
    },
    fname: String,
    isBatchDetail: Boolean,
    slug: String,
    modRoute: String,
  },
  components: {
    DxDataGrid,
    DxEditing,
    DxColumn,
    DxButton,
    DxDateBox,
    CustomFieldTypesList,
    RelateShow,
  },
  data: function () {
    return {
      itemDataGridRefKey: this.fname + "grid",
      ledgerDataGridRefKey,
      productRoute: "cnsl-products",
      sTotal,
      //columns: this.setColumnDefs(),
      newRowPosition: "last",
      lineItems: { data: [] },
      items: [],
      itemHeaders: [],
      summary: {
        recalculateWhileEditing: true,
        totalItems: [
          {
            column: "Amount",
            summaryType: "sum",
            displayFormat: "Total: {0}",
          },
        ],
      },
      toolbar: {
        visible: false,
      },
    };
  },
  methods: {
    grandchildMethod() {
      // Your method logic here
      console.log("Method in grandchild component called!");
      // this.$refs[this.itemDataGridRefKey].instance.saveEditData()
      this.save();
      this.$emit("update:modelValue", this.lineItems);
      // this.refreshDataGrid();
    },
    addNewRow() {
      this.itemDataGrid.addRow();
    },
    save(e) {
      this.itemDataGrid.saveEditData();
      console.log("Method in saved hello", this.fname);
    },
    onFocusCellChanged(newValue) {
      this.save();
      this.$emit("update:modelValue", this.lineItems);
    },

    handleCellClick(e) {
      if (
        e.column.editorType == "dxSelectBox" &&
        e.column.editCellTemplate != "cstm-field"
      ) {
        console.log(" handleCellClick Cell slectbox hai: ", e.column);
        e.cellElement.addEventListener("change", (event) => {
          this.save();
          this.$emit("update:modelValue", this.lineItems);
        });
      }
    },
    onCellPrepared(e) {
    console.log("onCellPrepared EValue",e);

    
      if (e.rowType === "data" && e.column.allowEditing) {
        
        if (  e.column.dataField == "cnsl_product_id" ||
        e.column.dataField == "product_id") {
          if (e.value != undefined) {

            if (e.column.dataField == "product_id") {
              this.productRoute = "products";
            }
            let url =
            "/" + this.slug + "/" + this.productRoute + "/getById/" + e.value;
            return axios
              .get(url)
              .then((response) => {
                console.log("FIELD LINE ITEM ", this.lineItems);
                if (this.lineItems.data.length != 0) {
                  this.lineItems.data[e.rowIndex].hsn = response.data.data.hsn;
                  this.lineItems.data[e.rowIndex].gst_rate =
                    response.data.data.gst_rate;
                }

                // response.data.data.name;
              })
              .catch((error) => {
                console.error("Error fetching dependent value:", error);
                // Optionally, you can throw the error to propagate it to the caller
                throw error;
              });
          }
        }

        e.cellElement.addEventListener("change", (event) => {
          console.log("onCellPrepared EValue phle = ",this.lineItems);

          this.save();
          console.log("onCellPrepared lineItems bad me = ",this.lineItems);

          this.$emit("update:modelValue", this.lineItems);
        });
      }
    },
    addDataSourceInList(data, slug) {
      console.log("addDataSourceInList DATA", this.data);
      data = data.map(({ editorType, editorOptions, ...obj }) =>
        editorType === "dxSelectBox" && !obj.lookup
          ? {
              ...obj,
              editorType,
              editorOptions,
              lookup: {
                dataSource: this.makeAsyncDataSource(
                  editorOptions.relateModule,
                  slug
                ),
                valueExpr: "id",
                displayExpr: "name",
              },
            }
          : {
              editorType,
              editorOptions,
              ...obj,
            }
      );

      return data;
    },
    makeAsyncDataSource(rRoute, slug) {
      return new CustomStore({
        key: "id",
        load: function (loadOptions) {
          let listurl = "/" + slug + "/" + rRoute + "/list";
          var parameters = {};
          var tFilter = [
            loadOptions.searchExpr,
            loadOptions.searchOperation,
            loadOptions.searchValue,
          ];

          if (loadOptions.sort) {
            parameters.order_column = loadOptions.sort[0].selector;
            if (loadOptions.sort[0].desc) parameters.order_direction = "asc";
          }
          if (
            loadOptions.searchExpr != null &&
            loadOptions.searchValue != null
          ) {
            parameters.filter = JSON.stringify(tFilter);
          }

          var config = {
            params: parameters,
          };
          return axios
            .get(listurl, config)
            .then((response) => {
              console.log("mytry", response.data.results.data);
              return {
                data: response.data.results.data,
                totalCount: response.data.results.total,
              };
            })
            .catch(() => {
              throw "Data Loading Error";
            });
        },
        byKey: function (key) {

          conosole.log("ByKey Call hua"+key);
          let url = "/" + slug + "/" + rRoute + "/getById/" + key;
          let data = {};
          //const response = await getRecordByIdasync(url);

          
          //return response.data;
        },
      });
    },
    refreshDataGrid() {
      console.log("refresh datagrid");
      this.itemDataGrid
        .refresh(true)
        .then(function () {})
        .catch(function (error) {});
    },
    setColumnDefs() {
      var serialDefs = [
        {
          width: 30,
          cellTemplate: function (cellElement, cellInfo) {
            cellElement.text(cellInfo.row.rowIndex);
          },
        },
      ];

      var columnDefs = serialDefs.concat(this.itemHeaders);
      return columnDefs;
    },
  },

  created: function () {},
  mounted() {
    this.itemHeaders = this.addDataSourceInList(this.def.line_items, this.slug);

    if (
      (typeof this.modelValue === "object" &&
        Object.keys(this.modelValue).length != 0) ||
      isProxy(this.modelValue)
    ) {
      if (this.isBatchDetail) {
        this.lineItems.data = this.modelValue;
      } else {
        this.lineItems.data = this.modelValue.data;
      }

      console.log("Line Item Component Model Value ", this.modelValue);
    }

    if (Object.keys(this.modelValue).length === 0) {
      //get form data fpr line item
      //  this.itemHeaders = this.def.line_items;
      //set blank first row only if its createiew
      this.addNewRow();
    }
  },
  computed: {
    itemDataGrid: function () {
      return this.$refs[this.itemDataGridRefKey].instance;
    },
  },
};
</script>